import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function projectStatesReducer(state = initialState.projectStates, action) {
    switch (action.type) {
        case types.GET_PROJECT_STATES_SUCCESS:
            return action.states;

        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/projectStatesReducer.js
 **/